export default __webpack_public_path__ + "static/media/courses.b48f1e6f.svg";